// import external modules
import { combineReducers } from "redux";
import loginReducer from "./login/loginReducer";
import gymReducer from "./gym/gymReducer";
import trainerReducer from "./trainer/trainerReducer";
import SocialMediaReducer from './socialMedia/socialMediaReducer'
import ClassReducer from './class/classReducer';
import UserReducer from "./user/userReducer";
import AccountReducer from './account/accountReducer';
import NotificationReducer from "./notification/notificationReducer";
import { reducer as toastrReducer } from "react-redux-toastr";
import LanguageDirectionReducer from "./languageDirection/languageDirectionReducer";
import ModalReducer from "./modal/modalReducer";
import CardReducer from "./card/cardReducer";
import AgreementReducer from "./agreement/agreementReducer";

const rootReducer = combineReducers({
  login: loginReducer,
  gymData: gymReducer,
  trainerData : trainerReducer,
  toastr: toastrReducer, // <- Mounted at toastr.
  socialMedia: SocialMediaReducer,
  classData : ClassReducer,
  accountData: AccountReducer,
  notification : NotificationReducer,
  userData: UserReducer,
  languageDirectionData : LanguageDirectionReducer,
  modal : ModalReducer,
  cards : CardReducer,
  agreements : AgreementReducer
});

export default rootReducer;
